import { configureStore } from '@reduxjs/toolkit';
import { languageReducer } from '@digitaltattoo/redux-slices';
import authSlice from './slices/authSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    language: languageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;